export default __webpack_public_path__ + "static/media/russia.d1c06b85.svg";